// Libraries
import styled from 'styled-components'

// Components
import { Aligner, Icon, InputText } from 'heeds-ds'

type Props = {
  visible?: boolean
  hovered?: boolean
  showBorder?: boolean
}

export const Container = styled.div.attrs(() => ({
  draggable: false,
}))<Props>`
  ${({ visible }) =>
    visible && 'box-shadow: 0px 4px 20px rgba(99, 90, 108, 0.1)'};
  background: ${({ hovered, theme }) =>
    hovered ? theme.colors.surface.hovered : theme.colors.surface.default};
  border-left: ${({ showBorder }) => (showBorder ? '4px' : 0)} solid
    ${({ theme }) => theme.colors.icon.default};
  border-radius: 4px;
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  padding: 16px 16px 12px;
  width: 100%;
`

export const ContentComment = styled.div<Props>`
  display: ${({ visible }) => (visible ? 'grid' : 'none')};
  grid-column: 1 / 3;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    grid-column: 1 / -1;
  }
`

export const ContentInputs = styled.div<Props>`
  column-gap: 8px;
  display: ${({ visible }) => (visible ? 'grid' : 'none')};
  grid-template-columns: 1fr;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    grid-template-columns: 3fr 2fr;
  }
`

export const CustomAligner = styled(Aligner)<Props>`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  transition: all 0.1s ease-in-out;
`

export const DeleteIcon = styled(Icon).attrs((props) => ({
  color: props.theme.colors.text.critical,
  iconName: 'delete',
  size: 20,
}))``

export const Header = styled(Aligner).attrs(() => ({
  align: 'center',
  gap: '16px',
  justify: 'space-between',
}))``

export const HiddenButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  background: none;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
`

export const Input = styled(InputText).attrs((props) => ({
  displayError: props.displayError,
  margin: '0',
  scale: 'small',
}))``

export const Label = styled.label`
  align-items: center;
  color: ${({ theme }) => theme.colors.text.default};
  cursor: pointer;
  display: flex;
  font-family: ${({ theme }) => theme.fontFamily.roboto};
  font-size: ${({ theme }) => theme.fontSize.copy4};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  gap: 1.2rem;
  line-height: 24px;
  margin: 0 0 2.4rem;
`

export const RowOne = styled.div`
  column-gap: 8px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`

export const RowTwo = styled.div`
  column-gap: 8px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`
